import { AuthService } from '@tassat/authentication';

import networkConfig, { getAuthConfiguration } from 'config/variables';
import history from 'Lib/browserHistory';
import { clearAuthCookie, establishAuthCookie } from 'Lib/establishAuthCookie';
// eslint-disable-next-line import/no-cycle
import PrimusWorker from 'Lib/worker/PrimusWorker';

AuthService.configurations({
    getAuthConfig: getAuthConfiguration,
    networkConfig: {
        adminIp: networkConfig.network.ADMIN_PUBLIC_IP,
        clientIp: networkConfig.network.CLIENT_PUBLIC_IP
    },
    history,
    onPostAuthentication: () => {
        establishAuthCookie();

        // Connect to platform
        // @ts-ignore
        if (typeof (window) !== 'undefined' && window.Worker && !window.adminWorkerInstance) {
            PrimusWorker.getInstance();
        }
    },
    onPostRefresh: () => {
        establishAuthCookie();
    },
    onPreLogout: async () => {
        await clearAuthCookie();
    },
    clientRoutingUrl: '/accounts'
});

const authService = new AuthService();

export default authService;